module.exports = __webpack_public_path__ + "facebook_squircle_charcoal.svg?2a0529a6092f9a8dbedfb3ec722d5d93";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/facebook_squircle_charcoal.svg
// module id = 138
// module chunks = 0